var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicEdit", {
    attrs: {
      value: _vm.value,
      "characteristic-items": _vm.meta.benefits,
      "characteristic-type": _vm.meta.benefitsType,
      title: "Benefits",
      "nothing-allowed": {
        onlyOverall: true,
        overall: {
          inFan: true,
          text: "Bei diesem Job gibt es keine Benefits"
        }
      },
      "selected-items-config": {
        showExperience: false
      },
      "label-type": "job-profile",
      "open-fan-button-alignment": "left",
      "open-fan-label": "Hinzufügen",
      "open-fan-label-with-selection": "Bearbeiten"
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }